/* Trusted Loan Access - key cutting bench estimator.
   Informational only. Amortized illustrative monthly range at the
   APR band declared on the section's data attributes. */
(function () {
  'use strict';

  var reduceMotion = false;
  if (window.matchMedia) {
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      reduceMotion = false;
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function monthlyPayment(principal, annualRate, months) {
    var r = annualRate / 100 / 12;
    if (r <= 0) { return principal / months; }
    var pow = Math.pow(1 + r, -months);
    return (principal * r) / (1 - pow);
  }

  function formatMoney(value) {
    var rounded = Math.round(value);
    return '$' + String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderFlip(group, text, animate) {
    group.textContent = '';
    for (var i = 0; i < text.length; i += 1) {
      var ch = text.charAt(i);
      var cell = document.createElement('span');
      cell.className = 'flipcell' + (/\d/.test(ch) ? '' : ' flipcell--sym');
      cell.textContent = ch;
      if (animate && !reduceMotion) {
        cell.style.setProperty('--f', String(i));
      } else {
        cell.style.animation = 'none';
      }
      group.appendChild(cell);
    }
  }

  ready(function () {
    var bench = document.querySelector('[data-estimator]');
    if (!bench) { return; }

    var aprLow = parseFloat(bench.getAttribute('data-apr-low')) || 7.99;
    var aprHigh = parseFloat(bench.getAttribute('data-apr-high')) || 25.49;

    var amountInput = bench.querySelector('[data-est-amount]');
    var termInput = bench.querySelector('[data-est-term]');
    var purposeInput = bench.querySelector('[data-est-purpose]');
    var amountLabel = bench.querySelector('[data-est-amount-label]');
    var termLabel = bench.querySelector('[data-est-term-label]');
    var lowGroup = bench.querySelector('[data-est-low]');
    var highGroup = bench.querySelector('[data-est-high]');
    var keyEl = bench.querySelector('[data-est-key]');

    if (!amountInput || !termInput || !lowGroup || !highGroup) { return; }

    var firstPaint = true;

    function fillTrack(input) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      var val = parseFloat(input.value);
      var pct = ((val - min) / (max - min)) * 100;
      input.style.setProperty('--p', pct + '%');
    }

    function update() {
      var amount = parseFloat(amountInput.value);
      var months = parseInt(termInput.value, 10);

      if (amountLabel) { amountLabel.textContent = formatMoney(amount); }
      if (termLabel) { termLabel.textContent = months + ' months'; }
      fillTrack(amountInput);
      fillTrack(termInput);

      var low = monthlyPayment(amount, aprLow, months);
      var high = monthlyPayment(amount, aprHigh, months);

      var animate = !firstPaint;
      renderFlip(lowGroup, formatMoney(low), animate);
      renderFlip(highGroup, formatMoney(high), animate);

      if (keyEl && animate && !reduceMotion) {
        keyEl.classList.remove('is-turned');
        void keyEl.offsetWidth; /* forced reflow to re-trigger */
        keyEl.classList.add('is-turned');
      }

      firstPaint = false;
    }

    amountInput.addEventListener('input', update);
    termInput.addEventListener('input', update);
    if (purposeInput) { purposeInput.addEventListener('input', update); }

    update();
  });
})();
